module.exports = __webpack_public_path__ + "img/under-construction.ccdad108.png";